import { Box, Button, Flex, Text, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getSenderIDLists } from "../../../API/account/senderId";

import Empty from "../../../components/UI/Empty";
import CreateSenderID from "../../../components/account/SenderIDs/CreateSenderID";
import CustomModal from "../../../components/UI/CustomModal";
import SenderIDListTable from "../../../components/account/SenderIDs/SenderIDListTable";
import Loader from "../../../components/UI/Loader";
import DomainsListTable from "../../../components/account/domains/DomainsListTable";
import CreateDomain from "../../../components/account/domains/CreateDomain";
import VerifyDomain from "../../../components/account/domains/VerifyDomain";
import ConfirmDomainEmail from "../../../components/account/domains/ConfirmDomainEmail";
import Verification from "../../../components/campaigns/EmailVisualBuilderComp/Verification";
import AuthenticationTable from "../../../components/account/domains/AuthenticationTable";

function DomainAuthentication() {
  const { isLoading, data } = useQuery(["senderIDData"], getSenderIDLists);
  const disclosure = useDisclosure();
  const verifyDisclosure = useDisclosure();
  const confirmDomainEmailDisclosure = useDisclosure();



  const Domains:any = [
    {
      domain: "charles.testing",
      status: "unverified",
    },
    {
      domain: "dipo.testing",
      status: "unverified",
    },
    {
      domain: "ife.testing",
      status: "verified",
    },
  ]
  return (
    <Box>
      <Flex>
        <Box>
        <Text fontSize={"20px"} color="grays.9" fontWeight={"700"}>
          Authenticate Domains
        </Text>
        <Text fontSize={"12px"} color="#7489AA" fontWeight={"500"}>
        You can manage and add domains here
        </Text></Box>

        <Button
          onClick={disclosure.onOpen}
          colorScheme={"primary"}
          ml="auto"
          size={"sm"}
          isDisabled={isLoading}
        >
          Add Domain
        </Button>
      </Flex>

      <Box mt="62px">
        {/* Empty */}
        {!isLoading && Domains?.length === 0 && (
          <Empty
            // title='You currently don’t have any sender ID added'
            description={
              <Text as="span">
                No Domains added yet
              </Text>
            }
            buttonText="Add & Verify Domains"
            buttonAction={disclosure.onOpen}
          />
        )}

        {isLoading && <Loader />}

        {!isLoading && Domains.length > 0 && (
          <AuthenticationTable/>
        )}
      </Box>

      <CustomModal
        disclosure={disclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Add Domain
          </Text>
        }
      >
        <CreateDomain close={disclosure.onClose} />
      </CustomModal>

      <CustomModal
        disclosure={verifyDisclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Verify Domain
          </Text>
        }
      >
        <Text color={"#7489AA"} fontSize={"12px"} fontWeight={500} my={3}>Please enter the email address at the domain you want to verify. </Text>
        {/* <VerifyDomain close={verifyDisclosure.onClose} confirmOpen={confirmDomainEmailDisclosure.onOpen}/> */}
      </CustomModal>

      <CustomModal
        disclosure={confirmDomainEmailDisclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Confirm email address
          </Text>
        }
      >
        <Text color={"#7489AA"} fontSize={"12px"} fontWeight={500} my={3}>Please enter the code sent to the email </Text>
        {/* <ConfirmDomainEmail close={confirmDomainEmailDisclosure.onClose} /> */}
        
      </CustomModal>
    </Box>
  );
}

export default DomainAuthentication;


